export default __webpack_public_path__ + "static/media/v2_roadmap_bg_shape.0bfdebe7.png";